export const TOKEN_PAGE_HEADER_HEIGHT = 64;
export const TOKEN_PAGE_GRID_ITEM_FOOTER_BIG_HEIGHT = 36;
export const TOKEN_PAGE_GRID_ITEM_FOOTER_SMALL_HEIGHT = 28;
export const TOKEN_PAGE_EDIT_MODAL_GUTTER = 32;
